import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList";
import themeConfig from "@/../themeConfig.js";
import colors from "@/../themeConfig.js";
import venuePortalMenuItems from "@/layouts/main/venuePortalMenuItems.js";
import cockpitMenuItems from "@/layouts/main/cockpitMenuItems.js";
import marcomMenuItems from "@/layouts/main/marcomMenuItems.js";
import campusMenuItems from "@/layouts/main/campusMenuItems.js";
import newsMenuItems from "@/layouts/main/newsMenuItems.js";
import crmMenuItems from "@/layouts/main/crmMenuItems.js";
import Vue from "vue";
import { _ } from "core-js";

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid: 0, // From Auth
  displayName: "John Doe", // From Auth
  about:
    "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL: require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status: "online",
  userRole: "admin",
};

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if ("ontouchstart" in window || window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

export default {
  namespaced: false,
  state: () => ({
    users: [],
    token: localStorage.getItem("token") || null,
    AppActiveUser: JSON.parse(localStorage.getItem("userInfo")) || userDefaults,
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    isVerticalRightNavMenuActive: false,
    is_touch_device: is_touch_device(),
    mainLayoutType: themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList: navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: "default",
    verticalRightNavMenuWidth: "default",
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList.pages.data.filter(
      page => page.is_bookmarked
    ),
    theme: themeConfig.theme || "light",
    themePrimaryColor: colors.primary,

    menuItems: [{
      name: "Venue Portal",
      permissionType: "entity",
      submenuItems: venuePortalMenuItems,
      hasVenueSelect: true,
      hasListManagement: false,
      permission: "vp.vp.show"
    }, {
      name: "Cockpit",
      permissionType: "global",
      submenuItems: cockpitMenuItems,
      hasVenueSelect: false,
      hasListManagement: true,
      permission: "vp.cockpit.show"
    },/* {
      name: "Marcom",
      permissionType: "entity",
      submenuItems: marcomMenuItems,
      hasVenueSelect: true,
      hasListManagement: false,
      permission: "vp.marcom.show"
    },*/ {
      name: "Campus",
      permissionType: "global",
      submenuItems: campusMenuItems,
      hasVenueSelect: false,
      hasListManagement: false,
      permission: "vp.campus.show"
    }, {
      name: "News",
      permissionType: "global",
      submenuItems: newsMenuItems,
      hasVenueSelect: false,
      hasListManagement: false,
      permission: null
    }, {
      name: "CRM",
      permissionType: "global",
      submenuItems: crmMenuItems,
      hasVenueSelect: false,
      hasListManagement: false,
      permission: "vp.crm.show"
    },],
    currentMenu: 4,
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null
  }),
  mutations: {
    // /////////////////////////////////////////////
    // DOMAIN
    // /////////////////////////////////////////////

    UPDATE_USERS(state, users) {
      state.users = users;
    },

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu

    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
      state.isVerticalNavMenuActive = value;
    },
    TOGGLE_IS_VERTICAL_RIGHT_NAV_MENU_ACTIVE(state, value) {
      state.isVerticalRightNavMenuActive = !state.isVerticalRightNavMenuActive;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
      state.reduceButton = val;
    },
    UPDATE_MAIN_LAYOUT_TYPE(state, val) {
      state.mainLayoutType = val;
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
      state.verticalNavMenuItemsMin = val;
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
      state.verticalNavMenuWidth = width;
    },
    UPDATE_VERTICAL_RIGHT_NAV_MENU_WIDTH(state, width) {
      state.verticalRightNavMenuWidth = width;
    },

    // VxAutoSuggest

    UPDATE_STARRED_PAGE(state, payload) {
      // find item index in search list state
      const index = state.navbarSearchAndPinList["pages"].data.findIndex(
        item => item.url == payload.url
      );

      // update the main list
      state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
        payload.val;

      // if val is true add it to starred else remove
      if (payload.val) {
        state.starredPages.push(
          state.navbarSearchAndPinList["pages"].data[index]
        );
      } else {
        // find item index from starred pages
        const index = state.starredPages.findIndex(
          item => item.url == payload.url
        );

        // remove item using index
        state.starredPages.splice(index, 1);
      }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
      const starredPagesMore = state.starredPages.slice(10);
      state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
      let downToUp = false;
      let lastItemInStarredLimited = state.starredPages[10];
      const starredPagesLimited = state.starredPages.slice(0, 10);
      state.starredPages = starredPagesLimited.concat(list);

      state.starredPages.slice(0, 10).map(i => {
        if (list.indexOf(i) > -1) downToUp = true;
      });

      if (!downToUp) {
        state.starredPages.splice(10, 0, lastItemInStarredLimited);
      }
    },

    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY(state, val) {
      state.bodyOverlay = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
      state.themePrimaryColor = val;
    },
    UPDATE_THEME(state, val) {
      state.theme = val;
    },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },
    UPDATE_WINDOW_SCROLL_Y(state, val) {
      state.scrollY = val;
    },

    UPDATE_SELECTED_MENU(state, val) {
      state.currentMenu = val
    },

    updateCockpitMenu(state, cockpitReports) {
      cockpitReports.forEach(e => {
        if (_.some(cockpitMenuItems[e.category].submenu, s => s.id === e.id) || !e.active) return;
        if (e.permission && e.permission !== "" && !Vue.prototype.$AuthService.hasPermission(e.permission)) return;
        cockpitMenuItems[e.category].submenu.push(
          {
            ...e,
            url: '/cp/report/' + e.id,
            name: e.title,
            slug: "cockpitReport",
          },
        )
      })
      cockpitMenuItems.forEach(e => {
        if (e.submenu && e.submenu.length > 1) {

          e.submenu = _.sortBy(e.submenu, t => t.index)
        }
      });
    }
  },
  actions: {
    // /////////////////////////////////////////////
    // DOMAIN
    // /////////////////////////////////////////////

    // Users


    updateCockpitMenu({ commit }, cockpitReports) {
      commit("updateCockpitMenu", cockpitReports);
    },

    updateUsers({ commit }, users) {
      commit("UPDATE_USERS", users);
    },

    updateSelectedMenu({ commit }, menuItem) {
      commit("UPDATE_MENU_ITEM", menuItem);
    },

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
    },

    updateVerticalRightNavMenuWidth({ commit }, width) {
      commit("UPDATE_VERTICAL_RIGHT_NAV_MENU_WIDTH", width);
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit("UPDATE_STARRED_PAGE", payload);
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit("ARRANGE_STARRED_PAGES_LIMITED", list);
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit("ARRANGE_STARRED_PAGES_MORE", list);
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit("TOGGLE_CONTENT_OVERLAY");
    },
    updateTheme({ commit }, val) {
      commit("UPDATE_THEME", val);
    }
  },
  getters: {
    currentMenu: state => state.currentMenu,
    menuItems: state => state.menuItems,
    currentMenuHasListManagement: state => state.menuItems[state.currentMenu].hasListManagement,
    // COMPONENT
    // vx-autosuggest
    // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    windowBreakPoint: state => {
      // This should be same as tailwind. So, it stays in sync with tailwind utility classes
      if (state.windowWidth >= 1200) return "xl";
      else if (state.windowWidth >= 992) return "lg";
      else if (state.windowWidth >= 768) return "md";
      else if (state.windowWidth >= 576) return "sm";
      else return "xs";
    },

    isRightMenuActive: state => state.isVerticalRightNavMenuActive,

    scrollbarTag: state => {
      return state.is_touch_device ? "div" : "VuePerfectScrollbar";
    }
  }
};
